<script>
    import OperationText from "../../ops/OperationText.svelte";

	import {crossfade, customFlip} from '../../../crossfade.js';
    const [send, receive] = crossfade

	export let length;
	export let values;
	export let direction = 'row';
	export let topPct = 0;
	export let leftPct = 0;
	export let valueOffset = 0;
	export let showBorder = false;
	export let currentValue = 0;

	const borderStyle = showBorder ? '1px solid red' : 'none';

	let main = direction == 'row' ? 'left' : 'top';
	let small = direction == 'row' ? 'top' : 'left';
</script>

<div
	class="track-wrapper"
	style="flex-direction:{direction}; top:{topPct}%; left:{leftPct}%; border:{borderStyle}"
>
	{#each Array(length).keys() as ix}
		{@const threshold = ix + valueOffset}
		{#if Object.keys(values).includes(threshold.toString())}
			{@const value = values[threshold]}
			<div class="multiplier">
				{#if typeof value === 'number'}
					<img src="assets/vp/vp-positive.png" alt="thr-{threshold}" />
					<div class="multiplier-label font-body">{`X${value}`}</div>
				{:else}
					<OperationText text={value} color="white" size={20} />
				{/if}
			</div>
		{:else}
			<div class="placeholder"></div>
		{/if}
		
	{/each}
</div>

<style lang="scss">
	.track-wrapper {
		position: absolute;
		display: flex;
		width: fit-content;
		height: fit-content;
	}
	.placeholder {
		width: 3.5em;
		height: 3.5em;
	}
	.multiplier {
		position: relative;
		justify-content: center;
		align-items: center;
		width: 3.5em;
		height: 3.5em;
		& > img {
			width: 1.6em;
		}
	}
	@mixin stroke($color: #000, $size: 1px) {
		text-shadow:
			-#{$size} -#{$size} 0 $color,
			0 -#{$size} 0 $color,
			#{$size} -#{$size} 0 $color,
			#{$size} 0 0 $color,
			#{$size} #{$size} 0 $color,
			0 #{$size} 0 $color,
			-#{$size} #{$size} 0 $color,
			-#{$size} 0 0 $color;
	}
	.multiplier-label {
		position: absolute;
		width: 100%;
		height: 100%;
		align-items: center;
		justify-content: center;
		font-size: calc(var(--width) / 20.5); //14px;
		font-weight: 800;
		line-height: 1;
		@include stroke(#fff, calc(var(--height) / 401)); //1px;
	}

	.marker {
		position: absolute;
		width: calc(var(--height) / 11);
    	height: calc(var(--height) / 11);
		outline: 2px solid white;
		transition: left 0.5s, top 0.5s;
		background-color: lime;
		
	}
</style>
